// DEMO CONTENT — sample testimonials for the template. Replace with real, permission-granted words.
export const kindWords = [
  {
    id: 'kw-1',
    quote: 'The flowers arrived looking as if they had been gathered that morning from a garden I wish I owned.',
    attribution: 'Sample testimonial',
    context: 'Birthday arrangement',
  },
  {
    id: 'kw-2',
    quote: 'Nothing felt arranged. Everything felt placed — quietly, carefully, with a kind of patience.',
    attribution: 'Sample testimonial',
    context: 'Wedding table flowers',
  },
  {
    id: 'kw-3',
    quote: 'Weeks later the dried stems still sit on my shelf. They changed slowly, and I loved them more each day.',
    attribution: 'Sample testimonial',
    context: 'Dried bouquet',
  },
];

// Leave empty to hide the "Open email" action. Set to a real business address to enable it.
export const enquiryRecipient = '';

export const occasions = ['Birthday', 'Wedding', 'Anniversary', 'Sympathy', 'Event or dinner', 'Just because', 'Other'];

export const budgets = ['Under $100', '$100 – $200', '$200 – $400', '$400+', 'Not sure yet'];

export const careFaq = [
  {
    id: 'seasonal',
    q: 'Are flowers seasonal?',
    a: 'Yes. We compose with what is growing well at the moment, so stems, colours and textures shift through the year. Each piece shown is a guide to mood and palette rather than an exact recipe.',
  },
  {
    id: 'care',
    q: 'How should I care for my arrangement?',
    a: 'Keep fresh flowers in a cool spot away from direct sun and fruit. Trim stems at an angle and refresh the water every two days. Dried flowers prefer a dry room and gentle handling.',
  },
  {
    id: 'custom',
    q: 'Can I request something custom?',
    a: 'Of course. Share the occasion, a date and a little of what you imagine, and we will prepare a composition just for you.',
  },
];